import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../store'

import { openHomebase } from './homebase'

interface MenuState {
  menuIsOpen: boolean
  menuIsExpanded: boolean
  hideHorizontalMenu: boolean
  horizontalMenuHeight: number
  showAllLearningTools: boolean
  showAllGames: boolean
}

const initialState: MenuState = {
  menuIsOpen: false,
  menuIsExpanded: false,
  hideHorizontalMenu: false,
  horizontalMenuHeight: 0,
  showAllLearningTools: false,
  showAllGames: false,
}

const slice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    open: (state) => {
      return { ...state, menuIsOpen: true, menuIsExpanded: true }
    },
    close: (state) => {
      return { ...state, menuIsOpen: false, menuIsExpanded: false, showAllGames: false, showAllLearningTools: false }
    },
    setHideHorizontalMenu: (state, action) => {
      return { ...state, hideHorizontalMenu: action.payload }
    },
    setHorizontalMenuHeight: (state, action) => {
      return { ...state, horizontalMenuHeight: action.payload }
    },
    setShowAllLearningTools: (state, action) => {
      return { ...state, showAllLearningTools: action.payload }
    },
    setShowAllGames: (state, action) => {
      return { ...state, showAllGames: action.payload }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(openHomebase.type, () => {
      return {
        menuIsOpen: false,
        menuIsExpanded: false,
        hideHorizontalMenu: false,
        horizontalMenuHeight: 0,
        showAllLearningTools: false,
        showAllGames: false,
      }
    })
  },
})

export const selectMenuIsOpen = (state: RootState): boolean => state.menu.menuIsOpen
export const selectMenuIsExpanded = (state: RootState): boolean => state.menu.menuIsExpanded
export const selectHideHorizontalMenu = (state: RootState): boolean => state.menu.hideHorizontalMenu
export const selectHideHorizontalMenuHeight = (state: RootState): number => state.menu.horizontalMenuHeight
export const selectShowAllLearningTools = (state: RootState): boolean => state.menu.showAllLearningTools
export const selectShowAllGames = (state: RootState): boolean => state.menu.showAllGames
export const {
  open: openMenu,
  close: closeMenu,
  setHideHorizontalMenu: setHideHorizontalMenuActionCreator,
  setHorizontalMenuHeight: setHorizontalMenuHeightActionCreator,
  setShowAllLearningTools: setShowAllLearningTools,
  setShowAllGames: setShowAllGames,
} = slice.actions

export default slice.reducer
